module.exports = __webpack_public_path__ + "5cdb7717eee2547f28e522ffdd26db1c.png";